export const blogUrl = "https://blog.triangular-pod.com/";
